import imgAggregates from '../../assets/landing/categories/aggregates.jpg';
import imgCement from '../../assets/landing/categories/cement.jpg';
import imgDoors from '../../assets/landing/categories/doors.jpg';
import imgElectrical from '../../assets/landing/categories/electrical.jpg';
import imgEquipment from '../../assets/landing/categories/equipment.jpg';
import imgFasteners from '../../assets/landing/categories/fasteners.jpg';
import imgFixtures from '../../assets/landing/categories/fixtures.jpg';
import imgFlooring from '../../assets/landing/categories/flooring.jpg';
import imgHvac from '../../assets/landing/categories/hvac.jpg';
import imgInsulation from '../../assets/landing/categories/insulation.jpg';
import imgLandscaping from '../../assets/landing/categories/landscaping.jpg';
import imgMetals from '../../assets/landing/categories/metals.jpg';
import imgMiscellaneous from '../../assets/landing/categories/miscellaneous.jpg';
import imgOthers from '../../assets/landing/categories/others.jpg';
import imgPaint from '../../assets/landing/categories/paint.jpg';
import imgPlumbing from '../../assets/landing/categories/plumbing.jpg';
import imgRoofing from '../../assets/landing/categories/roofing.jpg';
import imgSheetGoods from '../../assets/landing/categories/sheet_goods.jpg';
import imgTile from '../../assets/landing/categories/tile.jpg';
import imgTools from '../../assets/landing/categories/tools.jpg';
import imgVehicles from '../../assets/landing/categories/vehicles.jpg';
import imgWindows from '../../assets/landing/categories/windows.jpg';
import imgLumber from '../../assets/landing/categories/lumber.jpg';
import imgMasonry from '../../assets/landing/categories/masonry.jpg';

import type { Category } from './types';

const CATEGORY_IMAGES: Record<string, string> = {
  aggregates: imgAggregates,
  bulk: imgAggregates,
  cement: imgCement,
  concrete: imgCement,
  doors: imgDoors,
  electrical: imgElectrical,
  equipment: imgEquipment,
  machinery: imgEquipment,
  fasteners: imgFasteners,
  hardware: imgFasteners,
  fixtures: imgFixtures,
  finishes: imgFixtures,
  flooring: imgFlooring,
  hvac: imgHvac,
  insulation: imgInsulation,
  weatherproofing: imgInsulation,
  landscaping: imgLandscaping,
  exterior: imgLandscaping,
  lighting: imgElectrical,
  lumber: imgLumber,
  masonry: imgMasonry,
  metals: imgMetals,
  paint: imgPaint,
  coatings: imgPaint,
  plumbing: imgPlumbing,
  drainage: imgPlumbing,
  roofing: imgRoofing,
  siding: imgRoofing,
  sheet: imgSheetGoods,
  tile: imgTile,
  stone: imgTile,
  tools: imgTools,
  accessories: imgTools,
  vehicles: imgVehicles,
  windows: imgWindows,
  glazing: imgWindows,
  specialties: imgMiscellaneous,
  miscellaneous: imgMiscellaneous,
  others: imgOthers,
};

export const getCategoryImage = (category: Category): string => {
  const name = (category.name || category.id || '').toLowerCase();
  for (const [key, img] of Object.entries(CATEGORY_IMAGES)) {
    if (name.includes(key)) return img;
  }
  return imgOthers;
};
